import { cn } from "@/ds/utils";
import type { FC, PropsWithChildren, ReactNode } from "react";

export interface SectionHeaderProps extends PropsWithChildren {
	title: ReactNode;
	description?: ReactNode;
	leading?: ReactNode;
	className?: string;
}

export const SectionHeader: FC<SectionHeaderProps> = props => {
	const {
		title,
		description,
		leading,
		className,
		children
	} = props;

	return (
		<div className={cn("flex items-center gap-3 border-b p-3", className)}>
			{leading}

			<div className="min-w-0 flex-1">
				<div className="type-section truncate">{title}</div>

				{
					description &&
					<div className="type-meta truncate">{description}</div>
				}
			</div>

			{children}
		</div>
	);
};
